export const COLUMNS = [
  {
    Header: "Product Id",
    Footer: "Product Id",
    accessor: "productId",
    sticky: "left",
  },
  {
    Header: "Template Code",
    Footer: "Template Code",
    accessor: "code",
  },
  {
    Header: "Product Name",
    Footer: "Product Name",
    accessor: "productNameDisplay",
  },
  {
    Header: "Generated Date",
    Footer: "Generated Date",
    accessor: "generatedDate",
  },
  {
    Header: "Generated QR",
    Footer: "Generated QR",
    accessor: "totalqrcodecount",
  },

  {
    Header: "Status",
    Footer: "Status",
    accessor: "status",
  },

  {
    Header: "Download QR",
    Footer: "Download QR",
    accessor: "action",
  },
];
